import i18n from "../i18n";

const Validations = {
  required: (value) => (value ? undefined : i18n.t("validations.REQUIRED")),
  upc_required: (value) => {
    if (value === undefined) return i18n.t("validations.REQUIRED");
    const isNum = /^\d+$/.test(value);
    if (isNum === false) return i18n.t("validations.DIGIT");
    if (
      value.length !== 8 &&
      value.length !== 12 &&
      value.length !== 13 &&
      value.length !== 14 &&
      value.length !== 17
    )
      return i18n.t("validations.UPC_LENGTH");
    return undefined;
  },
  select_required: (value) =>
    (value && typeof value === "undefined") ||
    value === null ||
    value === "null"
      ? i18n.t("validations.REQUIRED")
      : undefined,
  select_required_related: (value, requiredSelection, toched) => {
    if (!toched) {
      return undefined;
    }
    if (requiredSelection) {
      return i18n.t("symptoms.NO_USER_SELECTED_ERROR_TEXT");
    }
    return typeof value === "undefined" || value === null || value === "null"
      ? i18n.t("validations.REQUIRED")
      : undefined;
  },
  email_phone: (value) =>
    value &&
    !(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ||
      /^[0-9+-/(/)]{6,20}$/i.test(value)
    )
      ? i18n.t("validations.EMAIL_ADDRESS")
      : undefined,
  email: (value) =>
    value &&
    !(
      // /^(?![.-])([a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+)*)(?<![.-])@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)(?:\.(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?))*\.[A-Za-z]{2,}$/.test(value)
      /^(?![.-])([a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+(?:-*[a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+)*(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+)*)(?<![.-])@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)(?:\.(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?))*\.[A-Za-z]{2,}$/.test(value)

    )
      ? i18n.t("validations.EMAIL_ADDRESS")
      : undefined,

  minLength: (min) => (value) =>
    value && value.length <= min
      ? `Must be ${min} characters or more`
      : undefined,
  maxLength: (max) => (value) =>
    value && value.length >= max
      ? `Must be same or less than ${max}`
      : undefined,
  min8: (value) =>
    value && value.length < 8 ? i18n.t("validations.MIN_LENGTH_5") : undefined,
  max15: (value) =>
    value && value.length > 15
      ? i18n.t("validations.MAX_LENGTH_15")
      : undefined,
  positive: (value) =>
    typeof value !== "undefined" && parseFloat(value) <= 0
      ? i18n.t("Must be bigger than 0")
      : undefined,
  min_one_uppercase: (value) =>
    !/^(?=.*[A-Z]).+$/.test(value)
      ? i18n.t("general.UPPERCASE_VALIDATION_TEXT")
      : undefined,
  min_one_lowercase: (value) =>
    !/^(?=.*[a-z]).+$/.test(value)
      ? i18n.t("general.LOWER_CASE_VALIDATION_TEXT")
      : undefined,
  min_one_number: (value) =>
    value && !/^(?=.*\d).+$/i.test(value)
      ? i18n.t("general.NUMBER_VALIDATION_TEXT")
      : undefined,
  min_one_special: (value) =>
    value && !/^(?=.*[-\\[?/.,":_~`';}{\|+=>(<!@#\)$%\^&\]*]).+$/i.test(value)
      ? i18n.t("general.CHARACTER_VALIDATION_TEXY")
      : undefined,
};
export default Validations;



// WEBPACK FOOTER //
// ./src/components/Validations.js